import React from 'react'
import WorkerAuthorTop from './WorkerAuthorTop'
import WorkerReview from '../workerReview/WorkerReview'
import WorkerAuthorTab from './WorkerAuthorTab'

const ProfileWorkerAuthor = () => {
  return (
    <div className='dashboard-content-box dashboard-profile'>
        <div className='top-profile-box'>
            <WorkerAuthorTop />
        </div>
        <div className='reviews-sec'>
          <WorkerReview />
        </div>
        <div className='worker-tabs-bottom-sec'>
          <WorkerAuthorTab />
        </div>
    </div>
  )
}

export default ProfileWorkerAuthor
